import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ApiService } from "./utilities/api.service";
import {
  User,
  Profile,
  Community,
  CommunityListConfig,
  DiscussionListConfig,
} from "../../models";
import {
  CommunityListResult,
  DiscussionListResult,
  ProfileListResult,
} from "../../interfaces";

@Injectable()
export class ProfileService {
  constructor(private apiService: ApiService) {}

  // -------------------------------------------------------------------------------
  // shared
  // -------------------------------------------------------------------------------

  public findOne(username: string): Observable<Profile> {
    // GET /api/profiles/:username
    const getURL = `/profiles/${username}`;

    return this.apiService
      .get(getURL)
      .pipe(map((data: { profile: Profile }) => data.profile));
  }

  public searchOne(term: string): Observable<ProfileListResult> {
    let params = { term: term };
    // GET /api/profiles/search/autocomplete
    const url = "/profiles/search/autocomplete";
    var finalParams = new HttpParams({ fromObject: params });

    return this.apiService.get(url, finalParams).pipe(map((data) => data));
  }

  public follow(username: string): Observable<Profile> {
    // POST /api/profiles/:username/follow
    const postURL = `/profiles/${username}/follow`;
    return this.apiService.post(postURL);
  }

  public unfollow(username: string): Observable<Profile> {
    // POST /api/profiles/:username/follow
    const postURL = `/profiles/${username}/follow`;
    return this.apiService.post(postURL);
  }

  // -------------------------------------------------------------------------------
  // communities
  // -------------------------------------------------------------------------------

  public findUserCommunities(
    user: User,
    config: CommunityListConfig
  ): Observable<CommunityListResult> {
    let params = {};

    Object.keys(config.filters).forEach((key) => {
      params[key] = config.filters[key];
    });

    // GET /api/profiles/:username/communities
    const userName = user.username;
    const getURL = `/profiles/${userName}/communities`;

    var finalParams = new HttpParams({ fromObject: params });
    return this.apiService.get(getURL, finalParams).pipe(map((data) => data));
  }

  public deleteMembership(user: User, community: Community, credentials: any) {
    const userName = user.username;
    const communityName = community.name;

    // POST /api/profiles/:profile/memberships/delete/:community
    const postURL = `/profiles/${userName}/memberships/delete/${communityName}`;
    return this.apiService.post(postURL, { user: credentials });
  }

  // -------------------------------------------------------------------------------
  // discussion
  // -------------------------------------------------------------------------------

  public findMany(
    username: string,
    config: DiscussionListConfig
  ): Observable<DiscussionListResult> {
    let params = {};

    Object.keys(config.filters).forEach((key) => {
      params[key] = config.filters[key];
    });

    // GET /api/profiles/:username/bookmarks
    const getURL = `/profiles/${username}/bookmarks`;
    var finalParams = new HttpParams({ fromObject: params });
    return this.apiService.get(getURL, finalParams).pipe(map((data) => data));
  }
}
